<template>
    <div
        class="lds-combo-input"
        ref="combo"
        tabindex="-1"
        v-click-outside="closeList"
        :class="{ 'active': focused || value, 'lds-combo-input--textarea': isTextarea }">
        <textarea-autosize
            v-if="isTextarea"
            class="lds-input"
            :value="value"
            @input="(val) => $emit('input', val)"
            @blur.native="$emit('blur')"
            @focus.native="openList"
            @keydown="handleKeydown"
            :name="label"
            :placeholder="label"
            rows="2" />

        <template v-else>
            <input
                type="text"
                autocomplete="off"
                :name="label"
                :value="value"
                :class="{ 'input-error': errorVisible }"
                @input="$emit('input', $event.target.value)"
                @blur="$emit('blur')"
                @focus="openList"
                @keydown="handleKeydown">
            <label
                v-if="label"
                class="lds-combo-input__label"
                :for="label">
                {{ label }}
            </label>

            <div
                v-if="errorVisible"
                class="lds-combo-input__error-text">
                {{ errorText }}
            </div>
        </template>

        <div
            v-if="menuIsOpen"
            class="lds-combo-input__list">
            <div
                v-for="(option, index) in options"
                :key="index"
                class="lds-combo-input__item"
                @mousedown="selectOption(getOptionValue(option))">
                {{ getOptionLabel(option) }}
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import vClickOutside from 'v-click-outside';
import TextareaAutosize from 'vue-textarea-autosize';

Vue.use(TextareaAutosize);

export default {
    name: 'ComboInput',
    directives: {
        clickOutside: vClickOutside.directive,
    },
    props: {
        value: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            default: () => [],
        },
        optionValue: {
            type: String,
            default: '',
        },
        optionLabel: {
            type: String,
            default: '',
        },
        errorVisible: {
            type: Boolean,
            default: false,
        },
        errorText: {
            type: String,
            default: 'Поле обязательно для заполнения',
        },
        isTextarea: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isOpen: false,
            focused: false,
        };
    },
    computed: {
        menuIsOpen() {
            return this.focused && this.options.length && this.value.trim() === '';
        },
    },
    methods: {
        getOptionValue(option) {
            if (this.optionValue) {
                return option[this.optionValue];
            }
            return option;
        },
        getOptionLabel(option) {
            if (this.optionLabel) {
                return option[this.optionLabel];
            }
            return option;
        },
        openList() {
            this.focused = true;
        },
        closeList() {
            this.focused = false;
        },
        selectOption(option) {
            this.$emit('input', option);
            this.closeList();
        },
        handleKeydown(event) {
            if (event.key === 'Backspace' || event.key === 'Delete') {
                this.focused = true;
            }
        },
    },
};
</script>
